import { NgModule } from '@angular/core';
import { MaterialModule } from '@app/app.design.module';
import { BotaoVoltarComponent } from '@componentes/shared/botao-voltar/botao-voltar.component';
import { ConfirmacaoDialogComponent } from '@componentes/shared/confirmacao-dialog/confirmacao-dialog.component';
import { Criptografia } from '@componentes/shared/criptografia/criptografia';
import { MatButtonLoadingDirective } from './../diretivas/mat-button-loading.directive';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  exports: [MatButtonLoadingDirective, PipesModule, BotaoVoltarComponent, ConfirmacaoDialogComponent, Criptografia],
  declarations: [MatButtonLoadingDirective, BotaoVoltarComponent, ConfirmacaoDialogComponent, Criptografia],
  imports: [MaterialModule]
})
export class CompartilhadoModule { }
